module.exports = __webpack_public_path__ + "img/second.fa394a1c.png";